import React from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import cn from 'classnames';
import Lottie from 'react-lottie-player';

import animationData from 'Shared/spiner_blue.json';
import logoPrint from '../../assets/print.svg';
import logoDownload from '../../assets/download.svg';
import LeftPart from './components/LeftPart';
import RightPart from './components/RightPart';
import Icon from 'Components/Icon/Icon';
import ModalRequestQuotation from 'Components/ModalRequestQuotation';
import withErrorBoundary from 'Components/ErrorBoundary/ErrorBoundary';
import { logger } from 'RootShared/utility/ErrorLogger';

import queryGetOrderDetails from './query';

const TabOrderDetail = () => {
  const history = useHistory();
  const { id } = useParams();

  const { data, loading, error } = useQuery(queryGetOrderDetails, {
    variables: {
      pk: +id,
    },
  });

  if (error) {
    logger.error(error);
    toast(error.message, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      closeButton: true,
      hideProgressBar: false,
    });
  }

  return (
    <div className="container tab-order-detail" data-testid="tab-order-detail">
      {loading && (
        <Lottie
          data-testid="tab_order_detail"
          className="lottie"
          loop={true}
          play={true}
          animationData={animationData}
          width={100}
          style={{ width: 100, height: 100, margin: '0px auto' }}
        />
      )}
      {data && (
        <div data-testid="tab-order-detail-data">
          <div className="tab-navigation-header">
            <div className="tab-navigation-header__wrapper" onClick={history.goBack}>
              <Icon name="icon-left" className="tab-navigation-header__icon-left" />
              <span data-testid="order-details-left-icon">BACK TO LIST</span>
            </div>
          </div>
          <div className={cn('tab-group-control-header', { 'tab-group-control-header--flex-end': !data.order.pdfUrl })}>
            {data.order.pdfUrl && (
              <>
                <a download href={data.order.pdfUrl}>
                  <div className="tab-group-control-header__btn tab-group-control-header__btn--outlined">
                    <img src={logoDownload} width="20" alt="download" />
                  </div>
                </a>
                <a href={data.order.pdfUrl} target="_blank" rel="noopener noreferrer">
                  <div className="tab-group-control-header__btn tab-group-control-header__btn--outlined">
                    <img src={logoPrint} alt="print" />
                  </div>
                </a>

                <Link
                  className="tab-group-control-header__btn tab-group-control-header__btn--contained"
                  to={`/customer/order/detail/${id}/?request_quotation`}
                >
                  <Icon name="icon-plus" />
                  <span data-testid="request-quotation-details">Request a quotation</span>
                </Link>
              </>
            )}
          </div>
          <div className="tab-order-detail__wrapper">
            <LeftPart data={data.order} />
            <RightPart data={data.order} />
          </div>
        </div>
      )}
      <ModalRequestQuotation />
    </div>
  );
};

export default withErrorBoundary(TabOrderDetail);
